/**
 * The partner banner set under public/assets/support/ — three sizes in two
 * variants, one for people who play with us and one for organisations that
 * back us, each in a German and an English artwork.
 *
 * The files are exported at exactly the sizes they are embedded at, which
 * is why scripts/optimize-images.js is told to leave them alone
 * (NEVER_OPTIMIZE): re-encoding them would degrade a deliberate export.
 */

const SITE_URL = "https://talesandlegends.org";

/** Exactly the tracking the campaign brief asks for — source and medium,
 * nothing appended. Language-specific target so a partner's readers land
 * on the homepage they can read. */
export function bannerTarget(lang) {
  return `${SITE_URL}/${lang}/?utm_source=partner&utm_medium=banner`;
}

/** The English artwork uses "player" where the German uses "spieler", so
 * the variant key and the filename fragment aren't the same string. */
const VARIANT_FILE_SUFFIX = {
  spieler: { de: "spieler", en: "player" },
  partner: { de: "partner", en: "partner" },
};

/** Alt text mirrors what each artwork actually says, per language. */
export const BANNER_VARIANTS = {
  spieler: {
    alt: {
      de: "Wir spielen bei Tales&Legends",
      en: "We play at Tales&Legends",
    },
  },
  partner: {
    alt: {
      de: "Partner von Tales&Legends – gemeinnütziges LARP in Sachsen",
      en: "Partner of Tales&Legends – non-profit LARP in Saxony",
    },
  },
};

export const BANNER_SIZES = [
  { key: "b300x100", width: 300, height: 100 },
  { key: "b468x60", width: 468, height: 60 },
  { key: "b250x250", width: 250, height: 250 },
];

export function bannerFile(sizeKey, variant, lang) {
  const prefix = lang === "en" ? "banner-en" : "banner";
  return `/assets/support/${prefix}-${sizeKey}-${VARIANT_FILE_SUFFIX[variant][lang]}.png`;
}

/**
 * The snippet a partner pastes into their own page. Absolute URLs
 * throughout (it runs on someone else's domain), explicit width/height so
 * their layout doesn't shift while it loads, and rel="noopener" because
 * target="_blank" without it hands our page a handle on theirs.
 */
export function bannerEmbedCode({ key, width, height }, variant, lang) {
  return [
    `<a href="${bannerTarget(lang)}" target="_blank" rel="noopener">`,
    `  <img src="${SITE_URL}${bannerFile(key, variant, lang)}"`,
    `       width="${width}" height="${height}"`,
    `       alt="${BANNER_VARIANTS[variant].alt[lang]}">`,
    `</a>`,
  ].join("\n");
}
